$(document).ready(function(){
  $('.slick-carousel').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay:true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const cartButton = document.querySelector('.cart-button');
  const closeButton = document.querySelector('.close-button');
  const cartBadge = document.querySelector('.cart-badge');

  // Close button functionality
  closeButton.addEventListener('click', () => {
    cartButton.classList.add('hidden'); // Hide the cart button
    cartBadge.classList.remove('hidden'); // Show the cart badge
  });

  // Toggle back to full view on clicking badge
  cartBadge.addEventListener('click', () => {
    cartBadge.classList.add('hidden'); // Hide the cart badge
    cartButton.classList.remove('hidden'); // Show the cart button
  });
});

document.addEventListener('DOMContentLoaded', () => {
    $('.category-carousel').slick({
      slidesToShow: 6,    // Show 5 items at a time
      slidesToScroll: 1,  // Scroll 1 item at a time
      speed: 1000, 
      arrows: false,       // Show arrows for navigation
      dots: false,        // Disable dots
      infinite: true,     // Enable infinite scrolling
      autoplay: false,     // Enable autoplay
      autoplaySpeed: 3000, // Autoplay speed in milliseconds
      centerMode: false,
      touchThreshold: 5,        // Reduces swipe sensitivity for smooth interactions
      easing: 'linear',  
      variableWidth: true,
      swipe: true,
      draggable: true,
      responsive: [
        {
          breakpoint: 1024, // Tablet view
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 768, // Mobile view
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 480, // Smaller devices
          settings: {
            slidesToShow: 6
          }
        }
      ]
    });
});

$(document).ready(function(){
    $('.carousel_image').slick({
        slidesToShow: 3, // Number of visible slides
        slidesToScroll: 1, // Number of slides to scroll
        autoplay: false, // Enable autoplay
        autoplaySpeed: 2000, // Speed of autoplay in ms
        dots: false, // Pagination dots
        arrows: false, // Enable navigation arrows
        responsive: [
        {
          breakpoint: 768,
          settings: {
          slidesToShow: 3 // Tablet view
          }
        },
        {
          breakpoint: 480,
          settings: {
          slidesToShow: 3 // Mobile view
          }
        }
      ]
    });
  });
document.addEventListener("DOMContentLoaded", function () {
  const addToCartButtons = document.querySelectorAll(".add-to-cart");

  addToCartButtons.forEach((button) => {
    button.addEventListener("click", function (event) {
      event.preventDefault();

      const productId = this.getAttribute("data-product-id");
      const payload = { id: productId, quantity: 1 };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add product to cart");
          }
          return response.json();
        })
        .then(() => {
          // Fetch updated cart data
          return fetch("/cart.js").then((response) => response.json());
        })
        .then((cart) => {
          // Dynamically update the cart UI
          updateCartUI(cart);
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        });
    });
  });

  function updateCartUI(cart) {
    const cartButton = document.querySelector(".cart-button");
    const cartBadge = document.querySelector(".cart-badge");
    const cartItems = document.querySelector(".cart-items");
    const cartPrice = document.querySelector(".cart-price");
    const badgeCount = document.querySelector(".badge-count");

    if (cart.item_count > 0) {
      // Update cart info
      cartItems.textContent = `${cart.item_count} Item${cart.item_count > 1 ? "s" : ""}`;
      cartPrice.textContent = `₹${(cart.total_price / 100).toFixed(2)}`;

      // Show cart button and badge
      cartButton.style.display = "flex";
      //cartBadge.classList.remove("hidden");
      badgeCount.textContent = cart.item_count;
    } else {
      // Hide cart button and badge if no items
      cartButton.style.display = "none";
      cartBadge.classList.add("hidden");
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const footerToggle = document.querySelector(".footer-toggle");
  const footerContent = document.querySelector(".tp-footer-top");
  const toggleIcon = footerToggle.querySelector(".toggle-icon");

  footerToggle.addEventListener("click", function () {
    const isExpanded = footerContent.classList.contains("expanded");
    footerContent.classList.toggle("expanded");
    footerContent.style.display = isExpanded ? "none" : "block";
    footerToggle.setAttribute("aria-expanded", !isExpanded);
    toggleIcon.textContent = isExpanded ? "+" : "−"; // Update icon
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const scrollSection = document.querySelector(".horizontal-scroll-section");

  // Enable smooth scrolling
  scrollSection.style.scrollBehavior = "smooth";

  // Optional: Automatic scrolling
  setInterval(() => {
    scrollSection.scrollBy({
      left: 150, // Amount to scroll each time
      behavior: "smooth",
    });
  }, 3000); // Adjust interval time as needed
});

  // Select the "Add to Cart" element
  const addToCart = document.querySelector('.add_to_cart_mobile');

  // Set up the IntersectionObserver
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        addToCart.classList.add('fixed_add'); // Add 'fixed' when the element scrolls into view
      } else {
        addToCart.classList.remove('fixed_add'); // Remove 'fixed' when it scrolls out of view
      }
    },
    {
      threshold: 0.1 // Trigger when 10% of the element is visible
    }
  );

  // Observe the "Add to Cart" element
  observer.observe(addToCart);